<template>
  <div class="news-detail">
    <div class="back-btn" @click="handleBack">返回</div>
    <div></div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue'
import { getCommonElementById, getStaticHtml, getOssUrls } from '@/api'
import { useStore } from 'vuex'
import { findSequences, findSequences2 } from '@/utils'
import router from '@/router'

const store = useStore()

// 返回处理函数：设置标记，告诉返回页面不要滚动到顶部
const handleBack = () => {
  // 设置标记，表示这次返回不需要滚动到顶部
  window.sessionStorage.setItem('keepScrollPosition', 'true');
  router.back();
}

onMounted(() => {
  if (document.documentElement && document.documentElement.scrollTop) {
    document.documentElement.scrollTop = 0;
  } else if (document.body) {
    document.body.scrollTop = 0
  }
  const path: any = JSON.parse(window.sessionStorage.getItem('path') || '{}');
  if (path.query?.htmlId) {
    getStaticHtml({ id: path.query?.htmlId }).then((html: any) => {
      const resultKeys = findSequences(html);
      const resultSources = findSequences2(html);
      getOssUrls(resultKeys).then((res: any) => {
        resultKeys.forEach((urlKey, i) => {
          html = html.replace(resultSources[i], `source src="${res[i]}`)
        });
        (document.querySelector('.news-detail div') as any).innerHTML = html
      })
    })
    return
  }
  getCommonElementById({ id: path.query?.id }).then((res: any) => {
    if (res.relatedHtmlId) {
      getStaticHtml({ id: res.relatedHtmlId }).then((html: any) => {
        const resultKeys = findSequences(html);
        const resultSources = findSequences2(html);
        getOssUrls(resultKeys).then((res: any) => {
          resultKeys.forEach((urlKey, i) => {
            html = html.replace(resultSources[i], `source src="${res[i]}`)
          });
          (document.querySelector('.news-detail div') as any).innerHTML = html
        })
      })
    }
  })
})
</script>
<style scoped lang="less">
.news-detail {
  width: 100%;
  font-size: 14px;
  min-height: calc(100vh - 469rem);
  position: relative;

  .back-btn {
    position: fixed;
    top: 80rem;
    left: 30rem;
    z-index: 100;
    color: #fff;
    font-size: 24rem;
    cursor: pointer;
    padding: 10rem 20rem;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 20rem;
  }

  &>div:last-child {
    width: 680rem;
    display: inline-block;
    padding: 100rem 0;
  }
}
</style>